import { ErrorHandler, Injectable } from '@angular/core';
import { ApplicationInsightsService } from 'core/applications-insights.service';

@Injectable()
export class GlobalErrorHandler implements ErrorHandler {

  constructor(
  ) { }

  handleError(error: Error) {
    console.log(error);
    throw error;
    // TODO Update with Samplicity Logging Strategy
  }
}
